import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { normalizeRole, ROLES } from '../../constants/roles';

export default function ProtectedRoute({ children, roles }) {
  const { isAuthenticated, user, bootstrapping } = useAuth();

  if (bootstrapping) {
    return (
      <div className="lms-loading-screen">
        <div className="loader" />
        <p>Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles?.length) {
    const role = normalizeRole(user?.role);
    if (!roles.includes(role)) {
      if (role === ROLES.PLATFORM_ADMIN) return <Navigate to="/platform" replace />;
      if (role === ROLES.ADMIN) return <Navigate to="/admin" replace />;
      if (role === ROLES.TEACHER) return <Navigate to="/teacher" replace />;
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
